import React from "react";
import Styled from "@emotion/styled";
import { useTranslations } from "next-intl";

function AlliancesSection() {
  const translation = useTranslations("mortgage.alliance");

  return (
    <ContainDetail className="details__container">
      <section className="details__description">
        <p className="details__text">
          {translation.rich("title", {
            highlight: (chunks) => (
              <span className="details__text_strong">{chunks}</span>
            ),
          })}
        </p>
      </section>
      <section className="details__logos">
        <img src={banckLogo.src} alt={banckLogo.alt} />
      </section>
    </ContainDetail>
  );
}

export default AlliancesSection;

const ContainDetail = Styled.div`
    display: flex;
    .details__logos {
        width: 50%;
    }
    .details__description {
        width: 40%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .details__logos {
        text-align: center;
    }

    img{
        width: 600px;
    }
    .details__text {
        font-size: 1.403rem;
        font-size: 400;
        max-width: 290px;
        margin: 0 auto;
        text-align: center;
    }
    .details__text_strong {
        font-weight: 700;
        color:var(--color-brand-blue-main);
    }
    @media screen and (max-width: 991px) {
        flex-direction: column;
        .details__description,
        .details__logos {
            width: 100%;
        }
        .details__description {
            margin-bottom: 50px;
        }
        img{
          width: 95%;
        }
    }
`;

const logos = [
  { src: "/icons/banco_ademi_logo.png", alt: "Logo Banco Ademi" },
  { src: "/icons/la_nacional_logo.png", alt: "Logo Asociación la Nacional" },
  { src: "/icons/asociacion_popular_logo.png", alt: "Logo Asociación Popular" },
  { src: "/icons/banco_caribe_logo.png", alt: "Logo Banco Caribe" },
  { src: "/icons/banco_union_logo.png", alt: "Logo Banco Unión" },
  { src: "/icons/banco_bdi_logo.png", alt: "Logo Banco BDI" },
  { src: "/icons/banco_bhd_leon_logo.png", alt: "Logo Banco BHD León" },
  {
    src: "/icons/banco_lopez_de_haro_logo.png",
    alt: "Logo Banco Lopez De Haro",
  },
  { src: "/icons/scotiabank_logo.png", alt: "Logo ScotiaBank" },
  {
    src: "/icons/vivienda_universales_rd_logo.png",
    alt: "Logo Viviendas Universales RD",
  },
  { src: "/icons/asociacion_cibao_logo.png", alt: "Logo Asociación Cibao" },
  { src: "/icons/banesco_contigo_logo.png", alt: "Logo Banesco Contigo" },
];

const banckLogo = {
  src: "/icons/bank/Aliados_Hipotecarios.png",
  alt: "Bancos afiliados",
};
